import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    ErrorLog: ErrorLog
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'name', 'account'])),
  created: function created() {
    // console.log(this.name, this.account, "account")
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.$store.dispatch('user/logout');
            case 1:
              this.$router.push("/login?redirect=".concat(this.$route.fullPath));
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }
};